export interface ChangelogEntry {
  date: string;
  title: string;
  highlights: string[];
}

export const changelog: ChangelogEntry[] = [
  {
    date: '2025-12-01',
    title: 'User-Blockierung',
    highlights: [
      'Neue Block-Funktion zum Blockieren von Benutzern',
      'Blockierte Benutzer können dein Profil nicht mehr besuchen',
      'Blockierte Benutzer können dir keine privaten Nachrichten mehr senden',
      'Verwaltung blockierter Benutzer im eigenen Profil',
      'System-Nachrichten und Admin-Nachrichten funktionieren weiterhin',
      'Admins können nicht blockiert werden',
    ],
  },
  {
    date: '2025-12-01',
    title: 'Likes & Favoriten',
    highlights: [
      'Logs können jetzt geliked werden - zeige deine Wertschätzung für tolle Funde!',
      'Like-Button im Dashboard und in der Detailansicht für schnellen Zugriff.',
      'Favoriten-Liste im eigenen Profil: Alle gelikten Logs an einem Ort.',
      'Like-Counts werden überall angezeigt, um die beliebtesten Funde zu sehen.',
      'Push-Benachrichtigungen für neue Nachrichten - verpasse keine wichtige Nachricht mehr.',
    ],
  },
  {
    date: '2025-12-01',
    title: 'Passwort-Verwaltung & Profiloptionen',
    highlights: [
      'Neues Profiloptionen-Dropdown im eigenen Profil für schnellen Zugriff auf Einstellungen.',
      'Passwort direkt im Profil ändern - keine separate Seite mehr nötig.',
      'Passwort vergessen? Neuer Flow mit E-Mail-Link zum Zurücksetzen.',
      'Sicherer Passwort-Reset mit zeitlich begrenzten Token für maximale Sicherheit.',
    ],
  },
  {
    date: '2025-12-01',
    title: 'Follow-Fixes & Deployment-Update',
    highlights: [
      'Follow-Buttons funktionieren wieder zuverlässig und benachrichtigen wie erwartet.',
      'Auf deinem eigenen Profil kannst du jetzt alle Followings sehen und direkt entfolgen.',
      'Im Dashboard sind Usernamen wieder klickbar und fallen bei fehlendem Namen auf einen Fallback zurück.',
      'Frontend-Builds werden jetzt automatisch auf den Webserver unter /var/www/cruising-ducks synchronisiert.',
      'Produktions-Build optimiert (Source Maps & Inline Runtime deaktiviert) für schnellere Deployments.',
    ],
  },
  {
    date: '2025-12-01',
    title: 'HEIC-Unterstützung, Kommentar-Updates, Dev-Chat & Filter',
    highlights: [
      'Fotos von iPhones (HEIC/HEIF) werden automatisch konvertiert.',
      'Fehler beim Enten-Loggen enthalten jetzt eine Referenz-ID und Details.',
      'Adminbereich zeigt die letzten Error-Logs übersichtlich an.',
      'Dashboard zeigt jetzt pro Fund, wie viele Kommentare vorhanden sind.',
      'Bei neuen Kommentaren auf eigene Funde erhältst du eine System-Nachricht mit Direktlink.',
      'Neuer Entwickler-Chat: angemeldete Nutzer können direkt Feedback und Ideen posten.',
      'Erweiterte Filter im Dashboard: nach Schiff, Benutzer, Zeitraum, mit/ohne Bild und mit/ohne Kommentare.',
      'Einfache Schimpfwort-Prüfung für Kommentare und Dev-Chat sorgt für freundlichere Inhalte.',
      'Kommentar-Meldungen haben jetzt Kategorien (Beleidigung, Spam, falscher Inhalt, Sonstiges).',
    ],
  },
  {
    date: '2025-11-30',
    title: 'Profile, Nachrichten & Moderation',
    highlights: [
      'Private Nachrichten inkl. Badge für ungelesene Konversationen.',
      'Admins können Duck-Logs, Kommentare und Meldungen verwalten.',
      'Benutzerprofile unterstützen Avatare & Biographien.',
    ],
  },
];


